import { render, staticRenderFns } from "./FuneralClients.vue?vue&type=template&id=3d5d2354&scoped=true&"
import script from "./FuneralClients.vue?vue&type=script&lang=js&"
export * from "./FuneralClients.vue?vue&type=script&lang=js&"
import style0 from "./FuneralClients.vue?vue&type=style&index=0&id=3d5d2354&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5d2354",
  null
  
)

export default component.exports